module.exports = __webpack_public_path__ + "media/images/course-card-default-7076192c.jpg";